var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 28,
    height: 28,
    transform: "translate(1784 345)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16",
    transform: "translate(-1784 -345)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_square_FILL0_wght400_GRAD0_opsz48",
    d: "M121.714,238.679A1.757,1.757,0,0,1,120,236.965V219.827a1.757,1.757,0,0,1,1.714-1.714h11.568l-1.714,1.714h-9.854v17.138h17.138v-9.94l1.714-1.714v11.654a1.757,1.757,0,0,1-1.714,1.714ZM130.283,228.4Zm5.2-10.054,1.228,1.2-8.141,8.112v2.456H131l8.169-8.169,1.2,1.2-8.655,8.683h-4.856v-4.856Zm4.884,4.8-4.884-4.8,2.856-2.856a1.724,1.724,0,0,1,2.428.029l2.4,2.428a1.708,1.708,0,0,1,.486,1.213,1.573,1.573,0,0,1-.514,1.186Z",
    transform: "translate(1666.227 132.16)",
    fill: "#0073b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.89c7bf6ef9ecc12737f408bc38d4e4f0.svg";
export { ForwardRef as ReactComponent };